import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

export default function SelectOld(props) {
	const { className, values, onChange, value } = props;
	const selectRef = useRef(null);

	useEffect(() => {
		MeddiApp.tools.selectpicker();
	}, []);

	useEffect(() => {
		const event = new CustomEvent('refresh', {
			bubbles: true,
		});

		setTimeout(() => {
			selectRef.current.dispatchEvent(event);
		}, 500);
	}, [values]);

	const handleChange = value => {
		onChange?.(value.target.value);
	};

	return (
		<div className={`form-group ${className}`}>
			<select
				className={'select-picker-v3 form-control'}
				ref={selectRef}
				onChange={handleChange}
				title={'Vyberte'}
				value={value}>
				{values?.map((value, index) => (
					<option key={index}>{value}</option>
				))}
			</select>
		</div>
	);
}

SelectOld.propTypes = {
	className: PropTypes.string,
	values: PropTypes.array,
};
